"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var components_1 = require("../../components");
var Attachment_1 = __importDefault(require("./Attachment"));
var react_intl_1 = require("react-intl");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var translationMessages = react_intl_1.defineMessages({
    attachment_title: {
        id: "attachment_title",
        defaultMessage: "Attachments",
    },
    attachment_tooltip_title: {
        id: "attachment_tooltip_title",
        defaultMessage: "The maximum size is {uploadSizeLimit}KB. Accepted file formats are JPG, PNG, PDF, CSV, XLSX and ODS.. Enclosed documents can be a copy of the original invoice, or timesheets for example."
    },
});
var AttachmentsGroup = function (props) {
    var tooltipTitle = (props.languageString === "en" || props.languageString === "is") && props.attachmentTooltipText
        ? props.attachmentTooltipText[props.languageString]
        : props.intl.formatMessage(translationMessages.attachment_tooltip_title, { uploadSizeLimit: props.uploadSizeLimit / 1024 });
    var attachmentLabelNode = (React.createElement(antd_1.Tooltip, { title: tooltipTitle, placement: "right" },
        React.createElement("span", null,
            props.intl.formatMessage(translationMessages.attachment_title),
            " ",
            React.createElement(icons_1.QuestionCircleOutlined, null))));
    return (React.createElement(components_1.ComponentContainer, { title: attachmentLabelNode },
        React.createElement(antd_1.Row, { gutter: [16, 16] },
            React.createElement(antd_1.Col, { span: 8 },
                React.createElement(Attachment_1.default, { key: "attachment1", fieldName: "file1", formInstance: props.formInstance, uploadSizeLimit: props.uploadSizeLimit, file: props.file1, setFile: props.setFile1, attachmentFieldValidation: props.attachmentFieldValidation1, setAttachmentFieldValidation: props.setAttachmentFieldValidation1 })),
            React.createElement(antd_1.Col, { span: 8 },
                React.createElement(Attachment_1.default, { key: "attachment2", fieldName: "file2", formInstance: props.formInstance, uploadSizeLimit: props.uploadSizeLimit, file: props.file2, setFile: props.setFile2, attachmentFieldValidation: props.attachmentFieldValidation2, setAttachmentFieldValidation: props.setAttachmentFieldValidation2 })),
            React.createElement(antd_1.Col, { span: 8 },
                React.createElement(Attachment_1.default, { key: "attachment3", fieldName: "file3", formInstance: props.formInstance, uploadSizeLimit: props.uploadSizeLimit, file: props.file3, setFile: props.setFile3, attachmentFieldValidation: props.attachmentFieldValidation3, setAttachmentFieldValidation: props.setAttachmentFieldValidation3 })))));
};
var AttachmentGroupIntl = react_intl_1.injectIntl(AttachmentsGroup);
exports.default = AttachmentGroupIntl;
